import styled from 'styled-components';
import {
    Alert,
    Box,
    CircularProgress,
    Dialog,
    Divider,
    FormControlLabel,
    InputAdornment,
    Radio,
    RadioGroup,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs, TabScrollButton,
    Tooltip,
    Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { colors } from '../../theme';
import { ACADEMIC_VIEW_TYPE, FACILITIES_VIEW_TYPE } from '../../constants';
import GlobalInput from '../../components/global/input';
import { ReactComponent as FilterIcon } from '../../assets/icons/filter-icon.svg';
import { ReactComponent as DownloadIcon } from '../../assets/icons/download-icon.svg';
import { ReactComponent as SaveIcon } from '../../assets/icons/refresh-icon.svg';
import { ReactComponent as WarningIcon } from '../../assets/icons/warning-icon.svg';
import { ReactComponent as CopyIcon } from '../../assets/icons/export-icon.svg';
import { ReactComponent as PasteIcon } from '../../assets/icons/download-icon.svg';
import GlobalButton from '../../components/global/button';
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh-icon.svg';
import FilterContainer from '../../components/layout/filterContainer';
import GlobalDropdown from '../../components/global/dropdown';
import React, {useEffect, useRef, useState} from 'react';
import DataGrid from '../../components/grid/dataGrid';
import moment from 'moment/moment';
import EventApi from '../../api/event.api';
import MEventApi from '../../api/mevent.api';
import { MOMENT_DATE_FORMAT, MOMENT_TIME_DISPLAY_FORMAT } from '../../constants/date_format';
import { CustomTableDropdownCell, CustomTableInputCell } from '../../components/grid/CustomTableCell';
import DialogTemplate from '../../components/dialogs/dialogTemplate';
import { toast } from 'react-toastify';
import { ReactComponent as EditIcon } from '../../assets/icons/edit-icon.svg';
import { ReactComponent as ClearIcon } from '../../assets/icons/clear-icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete-icon.svg';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-icon.svg';
import { downloadDocFile, downloadDocxFile, downloadExcelFile } from '../../helpers/file';
import { Downloading } from '@mui/icons-material';
import Button from '../../components/battleship/customButton';
import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';
import ContentContainer from '../../components/layout/contentContainer';
import {TextArea} from "@progress/kendo-react-inputs";
import {
    MenuButtonBold,
    MenuButtonBulletedList, MenuButtonColorPicker,
    MenuButtonItalic, MenuButtonOrderedList, MenuButtonStrikethrough, MenuButtonTextColor, MenuButtonUnderline,
    MenuControlsContainer,
    MenuDivider,
    MenuSelectHeading,
    RichTextEditor, RichTextEditorProvider,
    type RichTextEditorRef, RichTextField, RichTextContent
} from 'mui-tiptap';
import StarterKit from "@tiptap/starter-kit";
import {useEditor} from "@tiptap/react";
import GlobalLabel from "../../components/global/label";


const BannerEventDetails = (props: any) => {
    const _mEventApi = new MEventApi();
    const rteRef = useRef<RichTextEditorRef>(null);

    // event can be either managed event or banner event. They are similar but not same in terms of the field names
    const { event, onClose, clients, staffs, eventStatuses, itemCategories, items, rateCategories } = props;

    const [state, setState] = useState({
        showLoading: false,
        isUnsavedChanges: false,
        tabValue: event.bookingNumber ? 1 : 0,
        companies: [
            ...clients
                .map((client) => client.company) // extract the company objects
                .filter(
                    (
                        company,
                        index,
                        self, // filter to remove duplicates
                    ) => index === self.findIndex((c) => c.id === company.id), // compare based on company ID
                ),
        ],
        clientList: [],
        openConfirmDialog: false,
        openTaxDetailBreakdownDialog: false,
        openGenerateDocumentDialog: false,
        openApplySetupsForAllDaysDialog: false,
        selectedMEventItemList: null, // when a event function is selected in item list tab, this represents the mEventFunction. Using as a state for real-time update with input selection
        costSummary: null,
        isRichTextEditorFocused: false,
        confirmDoc: {
            doc: null,
            name: null,
        },
        quoteDoc: {
            doc: null,
            name: null,
        },
        contractDoc: {
            doc: null,
            name: null,
        },
        roomSetupDoc: {
            doc: null,
            name: null,
        },
        requestToInvoiceDoc: {
            doc: null,
            name: null,
        },
        itemListDialogParam: {
            name: '',
        },
        inputObject: {
            id: event.id,
            accountCode: event.accountCode,
            activityCode: event.activityCode,
            adminComment: event.adminComment,
            bookingNumber: event.bookingNumber, // this will be used as a flag, whether the event is managed event or banner event
            dateFeesPaid: event.dateFeesPaid ? moment(event.dateFeesPaid).format('YYYY-MM-DD') : null,
            deposit: event.deposit,
            detailsOfOtherCosts: event.detailsOfOtherCosts,
            fundCode: event.fundCode,
            generalComment: event.generalComment,
            internalFOAPALComment: event.internalFOAPALComment,
            isInternal: event.isInternal,
            locationCode: event.locationCode,
            organizationCode: event.organizationCode,
            programCode: event.programCode,
            pstExemptCode: event.pstExemptCode,
            roomSetupComment: event.roomSetupComment,
            eCrn: event.eventCRN,
            status: event.eventStatus ? event.eventStatus : eventStatuses.find((eventStatus) => eventStatus.name === 'Tentative'),
            rateCategory: event.rateCategory,
            eventTitle: event.eventTitle,
            startDate: moment(event.startDate).format('YYYY-MM-DD'),
            endDate: moment(event.endDate).format('YYYY-MM-DD'),
            eventStaff: event.staffAccount,
            contractReceivedDate: event.contractReceivedDate ? moment(event.contractReceivedDate).format('YYYY-MM-DD') : null,
            company: event.client?.company,
            client: event.client,
            eventFunctions: event.mEventFunctions ? event.mEventFunctions : event.eventFunctions,
        },
    });

    const richEditor = useEditor({
        extensions: [StarterKit],
        content: state.inputObject.roomSetupComment,
        onUpdate: ({editor}) => {
            let value = editor.getHTML();

            setState((prevState) => ({
                ...prevState,
                isUnsavedChanges: true,
                inputObject: {
                    ...prevState.inputObject,
                    roomSetupComment: value,
                },
            }));
        },
        onFocus: () => {
            setState((prevState) => ({
                ...prevState,
                isRichTextEditorFocused: true,
            }))
        },
        onBlur: () => {
            setState((prevState) => ({
                ...prevState,
                isRichTextEditorFocused: false,
            }))
        }
    });

    useEffect(() => {
        setState((prevState) => ({ ...prevState, showLoading: true }));
        try {
            if (state.inputObject.company) {
                _mEventApi.GetClientsByCompanyId(state.inputObject.company.id).then((clients) => {
                    setState((prevState) => ({
                        ...prevState,
                        clientList: clients,
                    }));

                    if (clients.find((client) => client.id === state.inputObject?.client?.id)) {
                        // do nothing
                    } else {
                        setState((prevState) => ({
                            ...prevState,
                            inputObject: {
                                ...prevState.inputObject,
                                client: null,
                            },
                        }));
                    }
                });
            }
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    }, [state.inputObject.company]);

    const onClickPushToEventGrid = () => {
        setState((prevState) => ({ ...prevState, showLoading: true }));
        try {
            if (!state.inputObject.company || !state.inputObject.client) {
                toast.error('Select company and client first to push to event grid.');
                return;
            }
            if (!state.inputObject.rateCategory) {
                toast.error("Select rate category first to push to event grid.")
                return;
            }
            if (!state.inputObject.eventStaff) {
                toast.error("Select event staff first to push to event grid.")
                return;
            }
            setState((prevState) => ({
                ...prevState,
                openConfirmDialog: true,
            }));
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    };

    const handlePushToEventGridDialogClose = () => {
        setState((prevState) => ({
            ...prevState,
            openConfirmDialog: false,
        }));
    };

    const handleOpenGenerateDocumentDialog = async () => {
        if (!state.openGenerateDocumentDialog) {
            // save only when Generate Document button is clicked
            await onSave();
        }
        
        setState((prevState) => ({
            ...prevState,
            openGenerateDocumentDialog: !prevState.openGenerateDocumentDialog,
        }));
    };

    const handleOpenApplySetupsForAllDaysDialog = () => {
        setState((prevState) => ({
            ...prevState,
            openApplySetupsForAllDaysDialog: !prevState.openApplySetupsForAllDaysDialog,
        }));
    };

    useEffect(() => {
        if (state.openGenerateDocumentDialog) {
            setState((prevState) => ({
                ...prevState,
                confirmDoc: {
                    doc: null,
                    name: null,
                },
                quoteDoc: {
                    doc: null,
                    name: null,
                },
                contractDoc: {
                    doc: null,
                    name: null,
                },
                roomSetupDoc: {
                    doc: null,
                    name: null,
                },
                requestToInvoiceDoc: {
                    doc: null,
                    name: null,
                }
            }));
            handleGenerateDocuments();
        }
    }, [state.openGenerateDocumentDialog]);

    useEffect(() => {
        if (state.tabValue === 2 && state.inputObject.bookingNumber) {
            setState((prevState) => ({
                ...prevState,
                inputObject: {
                    ...prevState.inputObject,
                    eventFunctions: [
                        ...prevState.inputObject.eventFunctions.map((eventFunction) => {
                            return {
                                ...eventFunction,
                                mEventFunctionItems: eventFunction.mEventFunctionItems.map((mEventFunctionItem) => ({
                                    ...mEventFunctionItem,
                                    itemCategory: mEventFunctionItem.item?.itemCategory,
                                })),
                            };
                        }),
                    ],
                },
            }));
        }
    }, [state.tabValue]);

    const handlePushToEventGrid = async () => {
        setState((prevState) => ({ ...prevState, showLoading: true }));
        try {
            const payload = {
                eventCRN: state.inputObject.eCrn,
                eventTitle: state.inputObject.eventTitle,
                eventStatus: state.inputObject.status,
                staffAccount: state.inputObject.eventStaff,
                rateCategory: state.inputObject.rateCategory,
                client: {
                    ...state.inputObject.client,
                },
            };
            const managedEvent = await _mEventApi.PostManagedEvent(payload);
            const clients = await _mEventApi.GetClientsByCompanyId(managedEvent.client.company.id);
            setState((prevState) => ({
                ...prevState,
                clientList: clients,
            }));
            setState((prevState) => ({
                ...prevState,
                openConfirmDialog: false,
                inputObject: {
                    ...prevState.inputObject,
                    id: managedEvent.id,
                    eCrn: managedEvent.eventCRN,
                    bookingNumber: managedEvent.bookingNumber,
                    eventTitle: managedEvent.eventTitle,
                    startDate: moment(managedEvent.startDate).format('YYYY-MM-DD'),
                    endDate: moment(managedEvent.endDate).format('YYYY-MM-DD'),
                    contractReceivedDate: managedEvent.contractReceivedDate ? moment(managedEvent.contractReceivedDate).format('YYYY-MM-DD') : null,
                    status: managedEvent.eventStatus,
                    rateCategory: managedEvent.rateCategory,
                    deposit: managedEvent.deposit,
                    dateFeesPaid: managedEvent.dateFeesPaid ? moment(managedEvent.dateFeesPaid).format('YYYY-MM-DD') : null,
                    isInternal: managedEvent.isInternal,
                    eventStaff: managedEvent.staffAccount,
                    client: managedEvent.client,
                    pstExemptCode: managedEvent.pstExemptCode,
                    fundCode: managedEvent.fundCode,
                    organizationCode: managedEvent.organizationCode,
                    accountCode: managedEvent.accountCode,
                    programCode: managedEvent.programCode,
                    activityCode: managedEvent.activityCode,
                    locationCode: managedEvent.locationCode,
                    detailsOfOtherCosts: managedEvent.detailsOfOtherCosts,
                    internalFOAPALComment: managedEvent.internalFOAPALComment,
                    generalComment: managedEvent.generalComment,
                    adminComment: managedEvent.adminComment,
                    roomSetupComment: managedEvent.roomSetupComment,
                    eventFunctions: managedEvent.mEventFunctions,
                },
            }));
            toast.success(`${managedEvent.bookingNumber} has been successfully pushed to the Event Grid!`, {
                icon: <CheckIcon color={colors.blue} />,
            });
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    };

    const onSave = async () => {
        setState((prevState) => ({ ...prevState, showLoading: true }));

        try {
            if (!state.inputObject.eventStaff) {
                toast.error("Select event staff to successfully save changes.")
                return;
            }
            
            if (!state.inputObject.rateCategory) {
                toast.error("Select rate category to successfully save changes.")
                return;
            }
            
            const payload = {
                id: state.inputObject.id,
                eventCRN: state.inputObject.eCrn,
                bookingNumber: state.inputObject.bookingNumber,
                eventTitle: state.inputObject.eventTitle,
                startDate: state.inputObject.startDate,
                endDate: state.inputObject.endDate,
                contractReceivedDate: state.inputObject.contractReceivedDate,
                eventStatus: state.inputObject.status,
                rateCategory: state.inputObject.rateCategory,
                deposit: state.inputObject.deposit,
                dateFeesPaid: state.inputObject.dateFeesPaid,
                isInternal: state.inputObject.isInternal,
                staffAccount: state.inputObject.eventStaff,
                client: state.inputObject.client,
                pstExemptCode: state.inputObject.pstExemptCode,
                fundCode: state.inputObject.fundCode,
                organizationCode: state.inputObject.organizationCode,
                accountCode: state.inputObject.accountCode,
                programCode: state.inputObject.programCode,
                activityCode: state.inputObject.activityCode,
                locationCode: state.inputObject.locationCode,
                detailsOfOtherCosts: state.inputObject.detailsOfOtherCosts,
                internalFOAPALComment: state.inputObject.internalFOAPALComment,
                generalComment: state.inputObject.generalComment,
                adminComment: state.inputObject.adminComment,
                roomSetupComment: state.inputObject.roomSetupComment,
                mEventFunctions: state.inputObject.eventFunctions,
            };

            const managedEvent = await _mEventApi.PutManagedEvent(payload);
            const clients = await _mEventApi.GetClientsByCompanyId(managedEvent.client.company.id);
            setState((prevState) => ({
                ...prevState,
                clientList: clients,
            }));

            setState((prevState) => ({
                ...prevState,
                inputObject: {
                    ...prevState.inputObject,
                    id: managedEvent.id,
                    eCrn: managedEvent.eventCRN,
                    bookingNumber: managedEvent.bookingNumber,
                    eventTitle: managedEvent.eventTitle,
                    startDate: moment(managedEvent.startDate).format('YYYY-MM-DD'),
                    endDate: moment(managedEvent.endDate).format('YYYY-MM-DD'),
                    contractReceivedDate: managedEvent.contractReceivedDate ? moment(managedEvent.contractReceivedDate).format('YYYY-MM-DD') : null,
                    status: managedEvent.eventStatus,
                    rateCategory: managedEvent.rateCategory,
                    deposit: managedEvent.deposit,
                    dateFeesPaid: managedEvent.dateFeesPaid ? moment(managedEvent.dateFeesPaid).format('YYYY-MM-DD') : null,
                    isInternal: managedEvent.isInternal,
                    eventStaff: managedEvent.staffAccount,
                    client: managedEvent.client,
                    pstExemptCode: managedEvent.pstExemptCode,
                    fundCode: managedEvent.fundCode,
                    organizationCode: managedEvent.organizationCode,
                    accountCode: managedEvent.accountCode,
                    programCode: managedEvent.programCode,
                    activityCode: managedEvent.activityCode,
                    locationCode: managedEvent.locationCode,
                    detailsOfOtherCosts: managedEvent.detailsOfOtherCosts,
                    internalFOAPALComment: managedEvent.internalFOAPALComment,
                    generalComment: managedEvent.generalComment,
                    adminComment: managedEvent.adminComment,
                    roomSetupComment: managedEvent.roomSetupComment,
                    eventFunctions: managedEvent.mEventFunctions,
                },
            }));

            let summary = await _mEventApi.GetCostSummary(state.inputObject.id);

            setState((prevState) => ({
                ...prevState,
                costSummary: summary,
            }));

            setState((prevState) => ({
                ...prevState,
                isUnsavedChanges: false
            }));

            toast.success(`${managedEvent.bookingNumber} has been saved`);
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    };

    const handleTabChange = async (event, newValue) => {
        
        // using separate if for readability
        if (state.tabValue === 1 && state.inputObject.eventFunctions?.some((ef) => ef.isEditMode)) {
            toast.error("You have unsaved changes. Click the check button to save before moving to another tab.");
            return;
        }
        // using separate if for readability
        if (state.tabValue === 2 && state.inputObject.eventFunctions?.some((ef) => ef.mEventFunctionItems?.some((mefi) => mefi.editMode))) {
            toast.error("You have unsaved changes. Click the check button to save before moving to another tab.");
            return;
        }

        // finance tab
        if (newValue === 3) {
            setState((prevState) => ({ ...prevState, showLoading: true }));
            try {
                let summary = await _mEventApi.GetCostSummary(state.inputObject.id);

                setState((prevState) => ({
                    ...prevState,
                    costSummary: summary,
                }));
            } finally {
                setState((prevState) => ({ ...prevState, showLoading: false }));
            }
        }
        
        setState((prevState) => ({
            ...prevState,
            tabValue: newValue,
        }));
    };

    const handleInputObject = (name: any, value: any) => {
        setState((prevState) => ({
            ...prevState,
            isUnsavedChanges: true,
        }));
        
        if (value === '') {
            value = null;
        }

        setState((prevState) => ({
            ...prevState,
            inputObject: {
                ...prevState.inputObject,
                [name]: value,
            },
        }));
    };

    const handleGenerateDocuments = () => {
        let errorHandled = false;

        const handleDownloadError = (error) => {
            if (errorHandled) return;
            errorHandled = true;

            toast.error('Error when downloading the document. Please reopen the dialog or contact the administrator.');
            setState((prevState) => ({
                ...prevState,
                openGenerateDocumentDialog: false,
            }));
        };

        _mEventApi
            .GetContractDoc(state.inputObject.id)
            .then((contractDoc) => {
                setState((prevState) => ({
                    ...prevState,
                    contractDoc: {
                        ...prevState.contractDoc,
                        doc: contractDoc,
                        name: `BCIT_Contract_${prevState.inputObject.bookingNumber}`,
                    },
                }));
            })
            .catch(handleDownloadError);

        _mEventApi
            .GetConfirmDoc(state.inputObject.id)
            .then((confirmDoc) => {
                setState((prevState) => ({
                    ...prevState,
                    confirmDoc: {
                        ...prevState.confirmDoc,
                        doc: confirmDoc,
                        name: `BCIT_Event_Confirmation_${state.inputObject.bookingNumber}`,
                    },
                }));
            })
            .catch(handleDownloadError);

        _mEventApi
            .GetQuoteDoc(state.inputObject.id)
            .then((quoteDoc) => {
                setState((prevState) => ({
                    ...prevState,
                    quoteDoc: {
                        ...prevState.quoteDoc,
                        doc: quoteDoc,
                        name: `BCIT_Event_Quote_${state.inputObject.bookingNumber}`,
                    },
                }));
            })
            .catch(handleDownloadError);

        _mEventApi
            .GetRoomSetupDoc(state.inputObject.id)
            .then((roomSetupDoc) => {
                setState((prevState) => ({
                    ...prevState,
                    roomSetupDoc: {
                        ...prevState.roomSetupDoc,
                        doc: roomSetupDoc,
                        name: `BCIT_Room_Setup_${state.inputObject.bookingNumber}`,
                    },
                }));
            })
            .catch(handleDownloadError);
        
        _mEventApi
            .GetRequestToInvoiceDoc(state.inputObject.id)
            .then((requestToInvoiceDoc) => {
                setState((prevState) => ({
                    ...prevState,
                    requestToInvoiceDoc: {
                        ...prevState.requestToInvoiceDoc,
                        doc: requestToInvoiceDoc,
                        name: `BCIT_Request_To_Invoice_${state.inputObject.bookingNumber}`
                    }
                }))
            })
    };

    const handleRadioButtonChange = (event) => {
        setState((prevState) => ({
            ...prevState,
            inputObject: {
                ...prevState.inputObject,
                isInternal: event.target.value
            }
        }));
    };
    
    const handleEventFunctionDelete = async (dataItem: any) => {
        setState((prevState) => ({ ...prevState, showLoading: true }));
        try {
            await _mEventApi.DeleteManagedEventFunction(dataItem.id);

            const managedEvent = await _mEventApi.GetManagedEventsById(state.inputObject.id);
            setState((prevState) => ({
                ...prevState,
                inputObject: {
                    ...prevState.inputObject,
                    id: managedEvent.id,
                    eCrn: managedEvent.eventCRN,
                    bookingNumber: managedEvent.bookingNumber,
                    eventTitle: managedEvent.eventTitle,
                    startDate: moment(managedEvent.startDate).format('YYYY-MM-DD'),
                    endDate: moment(managedEvent.endDate).format('YYYY-MM-DD'),
                    contractReceivedDate: managedEvent.contractReceivedDate ? moment(managedEvent.contractReceivedDate).format('YYYY-MM-DD') : null,
                    status: managedEvent.eventStatus,
                    rateCategory: managedEvent.rateCategory,
                    deposit: managedEvent.deposit,
                    dateFeesPaid: managedEvent.dateFeesPaid ? moment(managedEvent.dateFeesPaid).format('YYYY-MM-DD') : null,
                    isInternal: managedEvent.isInternal,
                    eventStaff: managedEvent.staffAccount,
                    client: managedEvent.client,
                    pstExemptCode: managedEvent.pstExemptCode,
                    fundCode: managedEvent.fundCode,
                    organizationCode: managedEvent.organizationCode,
                    accountCode: managedEvent.accountCode,
                    programCode: managedEvent.programCode,
                    activityCode: managedEvent.activityCode,
                    locationCode: managedEvent.locationCode,
                    detailsOfOtherCosts: managedEvent.detailsOfOtherCosts,
                    internalFOAPALComment: managedEvent.internalFOAPALComment,
                    generalComment: managedEvent.generalComment,
                    adminComment: managedEvent.adminComment,
                    roomSetupComment: managedEvent.roomSetupComment,
                    eventFunctions: managedEvent.mEventFunctions,
                },
            }));

            toast.success('Successfully deleted managed event function');
            return true;
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    }

    const handleEventFunctionSave = async (dataItem: any) => {
        setState((prevState) => ({ ...prevState, showLoading: true }));
        try {
            // event is a managed event (edit process)
            await _mEventApi.PutManagedEventFunction(dataItem);

            setState((prevState) => ({
                ...prevState,
                inputObject: {
                    ...prevState.inputObject,
                    eventFunctions: prevState.inputObject.eventFunctions.map((ef) =>
                        ef.id === dataItem.id ? { ...dataItem, isEditMode: false } : ef
                    ),
                },
            }));

            toast.success('Successfully updated managed event function');
            return true;
        } finally {
            setState((prevState) => ({ ...prevState, showLoading: false }));
        }
    };

    const renderClientGrid = (data: any, onChange: any, handleInputFocus: any) => {
        return (
            <>
                <TableCell sx={{ width: '11%' }}>{data?.company?.name}</TableCell>
                <TableCell sx={{ width: '11%' }}>{data?.subCompanyName}</TableCell>
                <TableCell sx={{ width: '10%' }}>{data?.firstName}</TableCell>
                <TableCell sx={{ width: '10%' }}>{data?.lastName}</TableCell>
                <TableCell sx={{ width: '13%' }}>{data?.contactEmail}</TableCell>
                <TableCell sx={{ width: '10%' }}>{data?.contactPhone}</TableCell>
                <TableCell sx={{ width: '35%' }}>{data?.comment}</TableCell>
            </>
        );
    };

    const renderEventFunctionGrid = (data: any, onChange: any, handleInputFocus: any) => {
        if (state.inputObject.bookingNumber) {
            // managed event
            return (
                <>
                    {!data.isBannerMatched ? (
                        <Tooltip
                            title={"The event function is not matched with Banner"}
                            arrow
                            placement="top"
                            PopperProps={{
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -15],
                                        },
                                    },
                                ],
                            }}
                        >
                            <TableCell sx={{ width: '2%' }}><WarningIcon/></TableCell>
                        </Tooltip>
                    ) : (
                        <TableCell sx={{ width: '2%' }}></TableCell>
                    )}
                    <TableCell sx={{ width: '8%' }}>{moment(data?.eventDate).format(MOMENT_DATE_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '8%' }}>{moment(data?.startTime, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '8%' }}>{moment(data?.endTime, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '5%' }}>{data?.room?.building?.buildingCode}</TableCell>
                    <TableCell sx={{ width: '5%' }}>{data?.room?.roomNumber}</TableCell>
                    <CustomTableInputCell 
                        sx={{ width: '8%', textAlign: 'right' }} 
                        data={data} 
                        type={'number'} 
                        parse={'int'}
                        name="attendees" 
                        onChange={onChange} 
                    />
                    <CustomTableInputCell
                        sx={{ width: '16%', textAlign: 'right' }}
                        data={data}
                        name="cost"
                        type={'currency'}
                        placeholder={data.roomPricing.hasDefaultPricing ? `Full: ${data.roomPricing.fullDayRate} | Half: ${data.roomPricing.halfDayRate}` : ``}
                        onChange={onChange}
                    />
                    <CustomTableInputCell sx={{ width: '42%' }} data={data} name="comment" onChange={onChange} />
                </>
            );
        } else {
            // banner event
            return (
                <>
                    <TableCell sx={{ width: '2%' }}></TableCell>
                    <TableCell sx={{ width: '8%' }}>{moment(data?.date).format(MOMENT_DATE_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '8%' }}>{moment(data?.timeIn, 'HH:mm:ss').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '8%' }}>{moment(data?.timeOut, 'HH:mm:ss').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                    <TableCell sx={{ width: '5%' }}>{data?.roomDto?.building?.name}</TableCell>
                    <TableCell sx={{ width: '5%' }}>{data?.roomDto?.number}</TableCell>
                    <TableCell sx={{ width: '8%' }}>{data?.attendees}</TableCell>
                    <TableCell sx={{ width: '16%' }}>{data?.currency}</TableCell>
                    <TableCell sx={{ width: '42%' }}>{data?.comment}</TableCell>
                </>
            );
        }
    };

    const renderItemListGridBannerEvent = (data: any, onChange: any, handleInputFocus: any) => {
        return (
            <>
                <TableCell sx={{ width: '6%' }}>{moment(data?.date).format(MOMENT_DATE_FORMAT)}</TableCell>
                <TableCell sx={{ width: '6%' }}>{moment(data?.timeIn, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                <TableCell sx={{ width: '6%' }}>{moment(data?.timeOut, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                <TableCell sx={{ width: '4%' }}>{data?.roomDto?.building?.name}</TableCell>
                <TableCell sx={{ width: '4%' }}>{data?.roomDto?.number}</TableCell>
                <TableCell sx={{ width: '5%', textAlign: 'right' }}>{data?.attendees}</TableCell>
                <TableCell sx={{ width: '40%' }}>{data?.comment}</TableCell>
            </>
        );
    };

    const renderItemListGridManagedEvent = (setExpandableRow, data: any, expandedRow: any, setExpandedRow: any, onChange: any) => {
        const expandRow = (expandedRow, setExpandedRow) => {
            setExpandedRow(data.id);

            setExpandableRow(data.mEventFunctionItems);
        };
        return (
            <TableRow 
                sx={{display: 'contents', cursor: 'pointer'}} 
                onClick={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedMEventItemList: {
                            ...prevState.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === data.id),
                        },
                    }));
                    
                    expandRow(expandedRow, setExpandedRow);
                }}
            >
                <TableCell sx={{ width: '6%', fontWeight: 'bold' }}>{moment(data?.eventDate).format(MOMENT_DATE_FORMAT)}</TableCell>
                <TableCell sx={{ width: '6%', fontWeight: 'bold' }}>{moment(data?.startTime, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                <TableCell sx={{ width: '6%', fontWeight: 'bold' }}>{moment(data?.endTime, 'HH:mm').format(MOMENT_TIME_DISPLAY_FORMAT)}</TableCell>
                <TableCell sx={{ width: '4%', fontWeight: 'bold' }}>{data?.room?.building?.buildingCode}</TableCell>
                <TableCell sx={{ width: '4%', fontWeight: 'bold' }}>{data?.room?.roomNumber}</TableCell>
                <TableCell sx={{ width: '5%', textAlign: 'right', fontWeight: 'bold' }}>{data?.attendees}</TableCell>
                <TableCell sx={{ width: '40%', fontWeight: 'bold' }}>{data?.comment}</TableCell>
            </TableRow>
        );
    };

    const renderItemListGridExpandable = (mEventFunction, itemListData, setExpandableRow) => {
        return (
            <Box
                className="sub-table-box"
                onClick={() => {
                    setState((prevState) => ({
                        ...prevState,
                        selectedMEventItemList: mEventFunction
                    }));
                }}
                sx={{
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: `${colors.blue.light}` } 
                }}
            >
                <Table size="small" sx={{ border: `1px solid ${colors.grey.light}`}}>
                    <TableHead sx={{ th: { borderBottom: `1px solid ${colors.grey.light}` } }}>
                        {/*<TableRow>*/}
                        <TableCell sx={{ width: '13%' }}>Category</TableCell>
                        <TableCell sx={{ width: '20%' }}>Item</TableCell>
                        <TableCell sx={{ width: '8%' }}># of Item</TableCell>
                        <TableCell sx={{ width: '11%' }}>Cost Per Item</TableCell>
                        <TableCell sx={{ width: '9%' }}>Total Charge</TableCell>
                        <TableCell sx={{ width: '20%' }}>Item Comment</TableCell>
                        <TableCell sx={{ width: '7%' }}></TableCell>
                        {/*</TableRow>*/}
                    </TableHead>
                    <TableBody>
                        {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems?.length > 0 &&
                            state.inputObject.eventFunctions
                                .find((eventFunction) => eventFunction.id === mEventFunction.id)
                                .mEventFunctionItems.map((entry, i) => {
                                const handleSelectedMEventItemList = (name: any, value: any) => {
                                    let itemList = [...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems];
                                    itemList[i][name] = value;
                                    setState((prevState) => ({
                                        ...prevState,
                                        inputObject: {
                                            ...prevState.inputObject,
                                            eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                if (eventFunction.id === mEventFunction.id) {
                                                    return {
                                                        ...eventFunction,
                                                        mEventFunctionItems: itemList,
                                                    };
                                                }
                                                return eventFunction;
                                            }),
                                        },
                                        selectedMEventItemList: {
                                            ...prevState.selectedMEventItemList,
                                            id: mEventFunction.id,
                                            mEventFunctionItems: itemList,
                                        },
                                    }));
                                };

                                return (
                                    <>
                                        {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].openNewItemListDialog && (
                                            <DialogTemplate
                                                title={
                                                    state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].itemCategory?.name
                                                }
                                                onClose={() => handleSelectedMEventItemList('openNewItemListDialog', false)}
                                                renderContent={() => {
                                                    return (
                                                        <>
                                                            <div style={{ width: '100%' }}>
                                                                <GlobalInput
                                                                    icon={<FilterIcon/>}
                                                                    label={"filter"}
                                                                    placeholder={'Search Item Name'}
                                                                    name={'name'}
                                                                    value={state.itemListDialogParam.name}
                                                                    onChange={(name: any, value: any) => {
                                                                        if (value === '') {
                                                                            value = '';
                                                                        }

                                                                        setState((prevState) => ({
                                                                            ...prevState,
                                                                            itemListDialogParam: {
                                                                                ...prevState.itemListDialogParam,
                                                                                [name]: value,
                                                                            },
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>

                                                            {/*<span>Select an item</span>*/}
                                                            <DataGrid
                                                                columns={newItemListDialogGridColumns}
                                                                topHeight={80}
                                                                data={items.filter((item) => {
                                                                    return (
                                                                        item.itemCategory.id ===
                                                                        state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]
                                                                            .itemCategory.id
                                                                        // Add the new filter using the AND operator (&&)
                                                                        && item.name.toLowerCase().includes(state.itemListDialogParam.name.toLowerCase())
                                                                    );
                                                                })}
                                                                dataItemKey={'id'}
                                                                clickable
                                                                renderRows={(data: any, onChange: any, handleInputFocus: any) => {
                                                                    return (
                                                                        <>
                                                                            <TableCell sx={{ width: '50%' }}>{data?.name}</TableCell>
                                                                            <TableCell sx={{ width: '50%' }}>{data?.description}</TableCell>
                                                                        </>
                                                                    );
                                                                }}
                                                                onRowClick={(item: any) => {
                                                                    let itemList = [
                                                                        ...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems,
                                                                    ];
                                                                    itemList[i].item = item;
                                                                    itemList[i].costPerItem = item.costPerItem;
                                                                    itemList[i].quantity = 1;
                                                                    itemList[i].editMode = true;
                                                                    itemList[i].openNewItemListDialog = false;
                                                                    setState((prevState) => ({
                                                                        ...prevState,
                                                                        inputObject: {
                                                                            ...prevState.inputObject,
                                                                            eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                                                if (eventFunction.id === mEventFunction.id) {
                                                                                    return {
                                                                                        ...eventFunction,
                                                                                        mEventFunctionItems: itemList,
                                                                                    };
                                                                                }
                                                                                return eventFunction;
                                                                            }),
                                                                        },
                                                                        selectedMEventItemList: {
                                                                            ...prevState.selectedMEventItemList,
                                                                            id: mEventFunction.id,
                                                                            mEventFunctionItems: itemList,
                                                                        },
                                                                    }));
                                                                }}
                                                            />
                                                        </>
                                                    );
                                                }}
                                            />
                                        )}
                                        <TableRow>
                                            <TableCell>
                                                {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode ? (
                                                    <GlobalDropdown
                                                        name={'name'}
                                                        field={'id'}
                                                        dataItemKey={'itemCategory'}
                                                        data={itemCategories}
                                                        value={
                                                            state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].itemCategory
                                                        }
                                                        onChange={(name: any, value: any) => {
                                                            let itemList = [
                                                                ...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems,
                                                            ];
                                                            itemList[i].item = null;
                                                            itemList[i].costPerItem = null;
                                                            itemList[i].quantity = null;
                                                            itemList[i].editMode = true;
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                inputObject: {
                                                                    ...prevState.inputObject,
                                                                    eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                                        if (eventFunction.id === mEventFunction.id) {
                                                                            return {
                                                                                ...eventFunction,
                                                                                mEventFunctionItems: itemList,
                                                                            };
                                                                        }
                                                                        return eventFunction;
                                                                    }),
                                                                },
                                                                selectedMEventItemList: {
                                                                    ...prevState.selectedMEventItemList,
                                                                    id: mEventFunction.id,
                                                                    mEventFunctionItems: itemList,
                                                                },
                                                            }));
                                                            handleSelectedMEventItemList(name, value);
                                                        }}
                                                        onClick={(event: MouseEvent) => {
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                selectedMEventItemList: {
                                                                    ...prevState.selectedMEventItemList,
                                                                    id: mEventFunction.id,
                                                                },
                                                            }));
                                                        }}
                                                    />
                                                ) : (
                                                    <>
                                                        {
                                                            state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].itemCategory
                                                                ?.name
                                                        }
                                                    </>
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].itemCategory &&
                                                state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode ? (
                                                    <Tooltip
                                                        title={
                                                            state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                ? state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                    .name
                                                                : 'Add an item...'
                                                        }
                                                        arrow
                                                        placement="top"
                                                        PopperProps={{
                                                            modifiers: [
                                                                {
                                                                    name: 'offset',
                                                                    options: {
                                                                        offset: [0, 0],
                                                                    },
                                                                },
                                                            ],
                                                        }}
                                                    >
                                                        <span>
                                                            <GlobalButton
                                                                disabled={
                                                                    !state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]
                                                                        .itemCategory ||
                                                                    !state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode
                                                                }
                                                                text={
                                                                    state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                        ? state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                            .name
                                                                        : 'Add an item...'
                                                                }
                                                                title={
                                                                    state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                        ? state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item
                                                                            .name
                                                                        : 'Add an item...'
                                                                }
                                                                onClick={() => {
                                                                    handleSelectedMEventItemList('openNewItemListDialog', true);
                                                                }}
                                                                style={{
                                                                    maxWidth: '16rem',
                                                                    padding: '0 10px',
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    justifyContent: 'flex-start'
                                                                }}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <>
                                                        {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]?.item
                                                            ? state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]?.item
                                                                ?.name
                                                            : 'Add an item...'}
                                                    </>
                                                )}
                                            </TableCell>
                                            {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item ? (
                                                <CustomTableInputCell
                                                    sx={{ textAlign: 'right' }}
                                                    data={state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]}
                                                    name="quantity"
                                                    type='number'
                                                    parse={'int'}
                                                    isDefault={
                                                        state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode
                                                    }
                                                    onChange={handleSelectedMEventItemList}
                                                />
                                            ) : (
                                                <TableCell/>
                                            )}
                                            {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item ? (
                                                <CustomTableInputCell
                                                    sx={{ textAlign: 'right' }}
                                                    data={state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]}
                                                    name="costPerItem"
                                                    type="currency"
                                                    isDefault={
                                                        state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode && state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item?.isPriceAdjustmentAllowed
                                                    }
                                                    onChange={handleSelectedMEventItemList}
                                                />
                                            ) : (
                                                <TableCell/>
                                            )}
                                            <TableCell>
                                                {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item ? (
                                                    <div style={{ textAlign: 'right' }}>
                                                        {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                                                            !isNaN(state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].quantity *
                                                                state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].costPerItem) ?
                                                                state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].quantity *
                                                                state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].costPerItem : 0
                                                        )}
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </TableCell>
                                            {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].item ? (
                                                <CustomTableInputCell
                                                    sx={{}}
                                                    data={state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]}
                                                    name="comment"
                                                    isDefault={
                                                        state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode
                                                    }
                                                    onChange={handleSelectedMEventItemList}
                                                />
                                            ) : (
                                                <TableCell/>
                                            )}
                                            <CommandTableCell align={'right'}>
                                                {state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].editMode ? (
                                                    <CheckIcon
                                                        id="check"
                                                        style={{ opacity: '0.5', pointerEvents: 'all' }}
                                                        onClick={async () => {
                                                            if (
                                                                !state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]
                                                                    .item ||
                                                                !state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]
                                                                    .itemCategory
                                                            ) {
                                                                toast.error('Item category and item must be selected');
                                                            } else {
                                                                let item = {
                                                                    id: state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id)
                                                                        .mEventFunctionItems[i].id,
                                                                    mEventFunctionId: mEventFunction.id,
                                                                    item: state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id)
                                                                        .mEventFunctionItems[i].item,
                                                                    quantity: state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id)
                                                                        .mEventFunctionItems[i].quantity,
                                                                    costPerItem: state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id)
                                                                        .mEventFunctionItems[i].costPerItem,
                                                                    comment: state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id)
                                                                        .mEventFunctionItems[i].comment,
                                                                    isActive: true
                                                                };
                                                                let response;
                                                                if (
                                                                    state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i]
                                                                        .id
                                                                ) {
                                                                    response = await _mEventApi.PutManagedEventFunctionItem(item);
                                                                } else {
                                                                    response = await _mEventApi.PostManagedEventFunctionItem(item);
                                                                }

                                                                let itemList = [
                                                                    ...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems,
                                                                ];
                                                                itemList[i] = response;
                                                                itemList[i].itemCategory = response.item.itemCategory;
                                                                setState((prevState) => ({
                                                                    ...prevState,
                                                                    inputObject: {
                                                                        ...prevState.inputObject,
                                                                        eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                                            if (eventFunction.id === mEventFunction.id) {
                                                                                return {
                                                                                    ...eventFunction,
                                                                                    mEventFunctionItems: itemList,
                                                                                };
                                                                            }
                                                                            return eventFunction;
                                                                        }),
                                                                    },
                                                                    selectedMEventItemList: {
                                                                        ...prevState.selectedMEventItemList,
                                                                        id: mEventFunction.id,
                                                                        mEventFunctionItems: itemList,
                                                                    },
                                                                }));

                                                                mEventFunction.mEventFunctionItems[i] = response;
                                                                mEventFunction.mEventFunctionItems[i].itemCategory = response.item.itemCategory;

                                                                handleSelectedMEventItemList('editMode', false);
                                                                toast.success("Item updated successfully");
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    <EditIcon
                                                        id="edit"
                                                        style={{ opacity: '0.5', pointerEvents: 'all' }}
                                                        onClick={() => {
                                                            handleSelectedMEventItemList('editMode', true);
                                                        }}
                                                    />
                                                )}
                                                <DeleteIcon
                                                    id="clear"
                                                    style={{ opacity: '0.5', pointerEvents: 'all' }}
                                                    onClick={async () => {
                                                        setState((prevState) => ({ ...prevState, showLoading: true }));
                                                        try {
                                                            if (state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].id) {
                                                                await _mEventApi.DeleteManagedEventFunctionItem(
                                                                    state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[i].id,
                                                                );
                                                            }

                                                            let itemList = [
                                                                ...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems,
                                                            ];
                                                            itemList.splice(i, 1);
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                inputObject: {
                                                                    ...prevState.inputObject,
                                                                    eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                                        if (eventFunction.id === mEventFunction.id) {
                                                                            return {
                                                                                ...eventFunction,
                                                                                mEventFunctionItems: itemList,
                                                                            };
                                                                        }
                                                                        return eventFunction;
                                                                    }),
                                                                },
                                                                selectedMEventItemList: {
                                                                    ...prevState.selectedMEventItemList,
                                                                    id: mEventFunction.id,
                                                                    mEventFunctionItems: itemList,
                                                                },
                                                            }));
                                                            mEventFunction.mEventFunctionItems.splice(i, 1);
                                                        } finally {
                                                            setState((prevState) => ({ ...prevState, showLoading: false }));
                                                        }
                                                    }}
                                                />
                                            </CommandTableCell>
                                        </TableRow>
                                    </>
                                );
                            })}
                        {/*{(state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems?.length <= 0 ||*/}
                        {/*    !state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems[*/}
                        {/*        state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems?.length - 1*/}
                        {/*    ].editMode) && (*/}
                        <TableRow>
                            <GlobalButton
                                style={{ padding: '0 10px' }}
                                text={'Add a new row...'}
                                onClick={() => {
                                    let itemList = [...state.inputObject.eventFunctions.find((eventFunction) => eventFunction.id === mEventFunction.id).mEventFunctionItems];
                                    itemList.push({
                                        editMode: true,
                                    });
                                    setState((prevState) => ({
                                        ...prevState,
                                        inputObject: {
                                            ...prevState.inputObject,
                                            eventFunctions: prevState.inputObject.eventFunctions.map((eventFunction) => {
                                                if (eventFunction.id === mEventFunction.id) {
                                                    return {
                                                        ...eventFunction,
                                                        mEventFunctionItems: itemList,
                                                    };
                                                }
                                                return eventFunction;
                                            }),
                                        },
                                        selectedMEventItemList: {
                                            ...prevState.selectedMEventItemList,
                                            id: mEventFunction.id,
                                            mEventFunctionItems: itemList,
                                        },
                                    }));
                                }}
                            />
                        </TableRow>
                        {/*)}*/}
                    </TableBody>
                </Table>
            </Box>
        );
    };

    return (
        <>
            {state.openGenerateDocumentDialog && (
                <DialogTemplate
                    title={'Documents'}
                    onClose={handleOpenGenerateDocumentDialog}
                    renderContent={() => {
                        return (
                            <>
                                <FlexBox sx={{ padding: '10px 0', width: '100%', flexDirection: 'row', justifyContent: 'center' }}>
                                    <GlobalButton
                                        sx={{ minWidth: '250px' }}
                                        text={state.contractDoc.doc ? 'Contract Document' : 'Downloading...'}
                                        startIcon={state.contractDoc.doc ? <DownloadIcon stroke={colors.blue.main} /> : <CircularProgress size={20} />}
                                        onClick={() => {
                                            if (state.contractDoc.doc) {
                                                downloadDocxFile(state.contractDoc.doc, state.contractDoc.name);
                                            } else {
                                                toast.warn('The document is being downloaded...');
                                            }
                                        }}
                                        disabled={!state.contractDoc.doc}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ padding: '10px 0',width: '100%', flexDirection: 'row', justifyContent: 'center' }}>
                                    <GlobalButton
                                        sx={{ minWidth: '250px' }}
                                        text={state.confirmDoc.doc ? 'Confirm Document' : 'Downloading...'}
                                        startIcon={state.confirmDoc.doc ? <DownloadIcon stroke={colors.blue.main} /> : <CircularProgress size={20} />}
                                        onClick={() => {
                                            if (state.confirmDoc.doc) {
                                                downloadDocxFile(state.confirmDoc.doc, state.confirmDoc.name);
                                            } else {
                                                toast.warn('The document is being downloaded...');
                                            }
                                        }}
                                        disabled={!state.confirmDoc.doc}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ padding: '10px 0',width: '100%', flexDirection: 'row', justifyContent: 'center' }}>
                                    <GlobalButton
                                        sx={{ minWidth: '250px' }}
                                        text={state.quoteDoc.doc ? 'Quote Document' : 'Downloading...'}
                                        startIcon={state.quoteDoc.doc ? <DownloadIcon stroke={colors.blue.main} /> : <CircularProgress size={20} />}
                                        onClick={() => {
                                            if (state.quoteDoc.doc) {
                                                downloadDocxFile(state.quoteDoc.doc, state.quoteDoc.name);
                                            } else {
                                                toast.warn('The document is being downloaded...');
                                            }
                                        }}
                                        disabled={!state.quoteDoc.doc}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ padding: '10px 0',width: '100%', flexDirection: 'row', justifyContent: 'center' }}>
                                    <GlobalButton
                                        sx={{ minWidth: '250px' }}
                                        text={state.roomSetupDoc.doc ? 'Room Setup Document' : 'Downloading...'}
                                        startIcon={state.roomSetupDoc.doc ? <DownloadIcon stroke={colors.blue.main} /> : <CircularProgress size={20} />}
                                        onClick={() => {
                                            if (state.roomSetupDoc.doc) {
                                                downloadDocxFile(state.roomSetupDoc.doc, state.roomSetupDoc.name);
                                            } else {
                                                toast.warn('The document is being downloaded...');
                                            }
                                        }}
                                        disabled={!state.roomSetupDoc.doc}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ padding: '10px 0',width: '100%', flexDirection: 'row', justifyContent: 'center' }}>
                                    <GlobalButton
                                        sx={{ minWidth: '250px' }}
                                        text={state.requestToInvoiceDoc.doc ? 'Request to Invoice Document' : 'Downloading...'}
                                        startIcon={state.requestToInvoiceDoc.doc ? <DownloadIcon stroke={colors.blue.main} /> : <CircularProgress size={20} />}
                                        onClick={() => {
                                            if (state.requestToInvoiceDoc.doc) {
                                                downloadDocxFile(state.requestToInvoiceDoc.doc, state.requestToInvoiceDoc.name);
                                            } else {
                                                toast.warn('The document is being downloaded...');
                                            }
                                        }}
                                        disabled={!state.requestToInvoiceDoc.doc}
                                    />
                                </FlexBox>
                                <FooterContent>
                                    <GlobalButton text="cancel" variant="outlined" onClick={handleOpenGenerateDocumentDialog} />
                                </FooterContent>
                            </>
                        );
                    }}
                />
            )}
            {state.openConfirmDialog && (
                <DialogTemplate
                    title={'Check Client Comment'}
                    disableTitleAutoUpperCase
                    disableCenteredContent
                    onClose={handlePushToEventGridDialogClose}
                    renderContent={() => {
                        return (
                            <div>
                                <span>{state.inputObject.client?.comment ? "Please review the saved comment for this client." : "There are no saved comments for this client."}</span>
                                {state.inputObject.client?.comment && (
                                    <>
                                        <ClientCommentLabel>Client Comment</ClientCommentLabel>
                                        <GlobalInput multiline minRows={3} value={state.inputObject.client?.comment} name={'comment'} disabled />
                                    </>
                                )}
                                <FooterContent style={{ justifyContent: 'space-between' }}>
                                    <GlobalButton sx={{ marginRight: '10px', borderRadius: '4px !important' }} text="cancel" variant="outlined" onClick={handlePushToEventGridDialogClose} />
                                    <GlobalButton sx={{ padding: '0px 20px !important' }} text={'Push to Event Grid'} onClick={handlePushToEventGrid} variant="round" />
                                </FooterContent>
                            </div>
                        );
                    }}
                />
            )}
            {state.openApplySetupsForAllDaysDialog && (
                <DialogTemplate
                    title={'Apply Setups For All Days'}
                    onClose={handleOpenApplySetupsForAllDaysDialog}
                    renderContent={() => {
                        return (
                            <div>
                                <span>
                                    Please review the items below:
                                    <ul>
                                        <li>If the items are <b>incorrect</b>, close this dialog, re-select the row, and click <b>"Apply Setups For All Days"</b> again.</li>
                                        <li>If <b>items are missing</b>, click the <b>Check button (&#10003;)</b> to save your changes.</li>
                                    </ul>
                                    New items will be appended to the existing functions.
                                </span>
                                <DataGrid
                                    data={state.selectedMEventItemList?.mEventFunctionItems?.filter((e) => !e.editMode) ?? []}
                                    columns={applySetupsForAllDaysGridColumns}
                                    topHeight={80}
                                    renderRows={(data: any, onChange: any, handleInputFocus: any) => {
                                        return (
                                            <>
                                                <TableCell sx={{ width: '11%' }}>{data?.item?.itemCategory?.name}</TableCell>
                                                <TableCell sx={{ width: '11%' }}>{data?.item?.name}</TableCell>
                                                <TableCell sx={{ width: '10%', textAlign: 'right' }}>{data?.quantity}</TableCell>
                                                <TableCell sx={{ width: '10%', textAlign: 'right' }}>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data?.costPerItem)}</TableCell>
                                                <TableCell sx={{ width: '13%', textAlign: 'right' }}>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data?.totalCost)}</TableCell>
                                            </>
                                        );
                                    }}
                                    dataItemKey={'id'}
                                />
                                <FooterContent>
                                    {!state.selectedMEventItemList?.mEventFunctionItems?.length || state.selectedMEventItemList.mEventFunctionItems.every((e) => e.editMode && !(e.item || e.itemCategory)) && (
                                        <GlobalLabel isError label={"No items selected"} />
                                    )}
                                    {state.selectedMEventItemList?.mEventFunctionItems?.some((e) => e.editMode && (e.item || e.itemCategory)) && (
                                        <GlobalLabel isError label={"Edit in progess"} />
                                    )}
                                    <GlobalButton
                                        sx={{ m: '10px' }}
                                        variant="round"
                                        text="Apply"
                                        disabled={
                                            !state.selectedMEventItemList?.mEventFunctionItems?.length
                                            || (
                                                state.selectedMEventItemList.mEventFunctionItems.some((e) => e.editMode && (e.item || e.itemCategory))
                                                ||
                                                state.selectedMEventItemList.mEventFunctionItems.every((e) => e.editMode && !(e.item || e.itemCategory))
                                            )
                                        }                                       
                                        onClick={async () => {
                                            setState((prevState) => ({ ...prevState, showLoading: true }));
                                            try {

                                                let list = state.selectedMEventItemList?.mEventFunctionItems.filter((e) => !e.editMode);
                                                await _mEventApi.SyncManagedEventFunctionItems(state.inputObject.id, state.selectedMEventItemList.id, list);

                                                const managedEvent = await _mEventApi.GetManagedEventsById(state.inputObject.id);
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    inputObject: {
                                                        ...prevState.inputObject,
                                                        id: managedEvent.id,
                                                        eCrn: managedEvent.eventCRN,
                                                        bookingNumber: managedEvent.bookingNumber,
                                                        eventTitle: managedEvent.eventTitle,
                                                        startDate: moment(managedEvent.startDate).format('YYYY-MM-DD'),
                                                        endDate: moment(managedEvent.endDate).format('YYYY-MM-DD'),
                                                        contractReceivedDate: managedEvent.contractReceivedDate ? moment(managedEvent.contractReceivedDate).format('YYYY-MM-DD') : null,
                                                        status: managedEvent.eventStatus,
                                                        rateCategory: managedEvent.rateCategory,
                                                        deposit: managedEvent.deposit,
                                                        dateFeesPaid: managedEvent.dateFeesPaid ? moment(managedEvent.dateFeesPaid).format('YYYY-MM-DD') : null,
                                                        isInternal: managedEvent.isInternal,
                                                        eventStaff: managedEvent.staffAccount,
                                                        client: managedEvent.client,
                                                        pstExemptCode: managedEvent.pstExemptCode,
                                                        fundCode: managedEvent.fundCode,
                                                        organizationCode: managedEvent.organizationCode,
                                                        accountCode: managedEvent.accountCode,
                                                        programCode: managedEvent.programCode,
                                                        activityCode: managedEvent.activityCode,
                                                        locationCode: managedEvent.locationCode,
                                                        detailsOfOtherCosts: managedEvent.detailsOfOtherCosts,
                                                        internalFOAPALComment: managedEvent.internalFOAPALComment,
                                                        generalComment: managedEvent.generalComment,
                                                        adminComment: managedEvent.adminComment,
                                                        roomSetupComment: managedEvent.roomSetupComment,
                                                        eventFunctions: [
                                                            ...managedEvent.mEventFunctions.map((eventFunction) => {
                                                                return {
                                                                    ...eventFunction,
                                                                    mEventFunctionItems: eventFunction.mEventFunctionItems.map((mEventFunctionItem) => ({
                                                                        ...mEventFunctionItem,
                                                                        itemCategory: mEventFunctionItem.item?.itemCategory,
                                                                    })),
                                                                };
                                                            }),
                                                        ],
                                                    },
                                                }));

                                                toast.success('Applied to all event functions');
                                                handleOpenApplySetupsForAllDaysDialog();
                                            } finally {
                                                setState((prevState) => ({ ...prevState, showLoading: false }));
                                            }
                                        }}
                                    />
                                </FooterContent>
                            </div>
                        );
                    }}
                />
            )}
            <Box>
                <FlexBox sx={{ mt: '5px', mb: '10px', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
                    <GlobalButton variant="round" text="Back to List" secondary={'true'} startIcon={<ArrowBackIcon />} onClick={onClose} disabled={state.showLoading} />
                    <FlexBox>
                        {!state.inputObject.bookingNumber && <GlobalButton variant="round" text="Push to Event Grid" onClick={onClickPushToEventGrid} disabled={state.showLoading} />}
                        {state.inputObject.bookingNumber && (
                            <Tooltip
                                title={state.tabValue === 1 || state.tabValue === 2 ? "Generating documents is not available within the Functions or Item List tabs." : ""}
                                arrow
                                placement="bottom"
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            textAlign: 'center',
                                            maxWidth: '250px',
                                        },
                                    },
                                }}
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 0],
                                            },
                                        },
                                    ],
                                }}
                            >
                                <span><GlobalButton variant="round" startIcon={<DownloadIcon />} text="Generate Document" onClick={handleOpenGenerateDocumentDialog} disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2} /></span>
                            </Tooltip>
                        )}
                        {state.inputObject.bookingNumber && (
                            <Tooltip
                                title={state.tabValue === 1 || state.tabValue === 2 ? "Saving is not available within the Functions or Item List tabs." : ""}
                                arrow
                                placement="bottom"
                                componentsProps={{ 
                                    tooltip: {
                                        sx: {
                                            textAlign: 'center', 
                                            maxWidth: '250px',   
                                        },
                                    },
                                }}
                                PopperProps={{
                                    modifiers: [
                                        {
                                            name: 'offset',
                                            options: {
                                                offset: [0, 0],
                                            },
                                        },
                                    ],
                                }}
                            >
                                <span><GlobalButton startIcon={<SaveIcon />} variant="round" text="Save" onClick={onSave} disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2} /></span>
                            </Tooltip>
                        )}
                    </FlexBox>
                </FlexBox>

                {state.tabValue === 1 && state.inputObject.eventFunctions?.some((ef) => ef.isEditMode) && (
                    <Alert sx={{ marginBottom: '5px'}} icon={<WarningIcon />} severity="warning">
                        You have unsaved changes on this tab. Click the check button to save before moving to another tab.
                    </Alert>
                )}
                {state.tabValue === 2 && state.inputObject.eventFunctions?.some((ef) => ef.mEventFunctionItems?.some((mefi) => mefi.editMode)) && (
                    <Alert sx={{ marginBottom: '5px'}} icon={<WarningIcon />} severity="warning">
                        You have unsaved changes on this tab. Click the check button to save before moving to another tab.
                    </Alert>
                )}
                {state.isUnsavedChanges && (
                    <Alert sx={{ marginBottom: '5px'}} icon={<WarningIcon />} severity="warning">
                        You have unsaved changes. Make sure to click save button.
                    </Alert>
                )}

                <FilterContainer sx={{ flexDirection: 'column', p: '7px' }}>
                    <FlexBox sx={{ mt: '10px', alignItems: 'flex-start', justifyContent: 'space-between', flexDirection: 'row', width: '100%' }}>
                        <FlexBox sx={{ flexDirection: 'column', width: '15%' }}>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>Booking #</Label>
                                <GlobalInput name={'bookingNumber'} value={state.inputObject.bookingNumber} placeholder={'Booking #'} disabled />
                            </FlexBox>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>Start Date</Label>
                                <GlobalInput type="date" name={'startDate'} value={state.inputObject.startDate} onChange={handleInputObject} disabled />
                            </FlexBox>
                        </FlexBox>
                        <FlexBox sx={{ flexDirection: 'column', width: '15%' }}>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>ECRN</Label>
                                <GlobalInput name={'eCrn'} value={state.inputObject.eCrn} placeholder={'ECRN'} disabled />
                            </FlexBox>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>End Date</Label>
                                <GlobalInput type="date" name={'endDate'} value={state.inputObject.endDate} onChange={handleInputObject} disabled />
                            </FlexBox>
                        </FlexBox>
                        <FlexBox sx={{ flexDirection: 'column', width: '15%' }}>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>Status</Label>
                                <GlobalDropdown
                                    name={'name'}
                                    field={'id'}
                                    dataItemKey={'status'}
                                    value={state.inputObject.status}
                                    data={eventStatuses}
                                    onChange={handleInputObject}
                                    disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2}
                                />
                            </FlexBox>
                            <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                <Label>Event Staff <span>*</span></Label>
                                <GlobalDropdown
                                    id={'id'}
                                    field={'id'}
                                    renderValue={(staffAccount) => {
                                        return `${staffAccount.lastName}, ${staffAccount.firstName}`;
                                    }}
                                    renderData={(staffAccount) => {
                                        return `${staffAccount.lastName}, ${staffAccount.firstName}`;
                                    }}
                                    data={[...staffs].sort((a, b) => {
                                        const nameA = `${a.lastName}, ${a.firstName}`;
                                        const nameB = `${b.lastName}, ${b.firstName}`;
                                        return nameA.localeCompare(nameB);
                                    })}
                                    value={state.inputObject.eventStaff}
                                    name={'bcitID'}
                                    dataItemKey={'eventStaff'}
                                    onChange={handleInputObject}
                                    placeholder={'Select Event Staff'}
                                    isRenderData
                                    isRenderValue
                                    isSearch
                                    disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2}
                                />
                            </FlexBox>
                        </FlexBox>
                        <FlexBox sx={{ marginLeft: '15px', flexDirection: 'column', width: '55%' }}>
                            <FlexBox sx={{ flexDirection: 'row', width: '100%' }}>
                                <FlexBox sx={{ flexDirection: 'column', width: '30%' }}>
                                    <Label>Rate Type <span>*</span></Label>
                                    <GlobalDropdown
                                        name={'name'}
                                        field={'id'}
                                        dataItemKey={'rateCategory'}
                                        value={state.inputObject.rateCategory}
                                        data={rateCategories}
                                        onChange={handleInputObject}
                                        disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ flexDirection: 'column', width: '70%' }}>
                                    <Label>Event Title</Label>
                                    <GlobalInput name={'eventTitle'} value={state.inputObject.eventTitle} onChange={handleInputObject} disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2} />
                                </FlexBox>
                            </FlexBox>
                            <FlexBox sx={{ flexDirection: 'row', width: '100%' }}>
                                <FlexBox sx={{ flexDirection: 'column', width: '30%' }}>
                                    <Label>Contract Received Date</Label>
                                    <GlobalInput name={'contractReceivedDate'} type="date" value={state.inputObject.contractReceivedDate} onChange={handleInputObject} disabled={state.showLoading || state.tabValue === 1 || state.tabValue === 2} />
                                </FlexBox>
                                <FlexBox sx={{ flexDirection: 'column', width: '40%' }}>
                                    <Label>Company <span>*</span></Label>
                                    <GlobalDropdown
                                        isSearch
                                        name={'name'}
                                        field={'id'}
                                        dataItemKey={'company'}
                                        value={state.inputObject.company}
                                        data={state.companies}
                                        onChange={handleInputObject}
                                        placeholder={'Select Company'}
                                        disabled={state.tabValue !== 0 || state.showLoading}
                                    />
                                </FlexBox>
                                <FlexBox sx={{ flexDirection: 'column', width: '30%' }}>
                                    <Label>Contact <span>*</span></Label>
                                    <GlobalDropdown
                                        id={'id'}
                                        field={'id'}
                                        renderValue={(client) => {
                                            return `${client.lastName}, ${client.firstName}`;
                                        }}
                                        renderData={(client) => {
                                            return `${client.lastName}, ${client.firstName}`;
                                        }}
                                        // isSearch
                                        data={state.clientList}
                                        value={state.inputObject.client}
                                        name={'contactEmail'}
                                        dataItemKey={'client'}
                                        onChange={handleInputObject}
                                        isRenderData
                                        isRenderValue
                                        isSearch
                                        disabled={!state.inputObject.company || state.tabValue !== 0 || state.showLoading}
                                        placeholder={'Select Contact'}
                                    />
                                </FlexBox>
                            </FlexBox>
                        </FlexBox>
                    </FlexBox>
                </FilterContainer>
            </Box>
            <Tabs value={state.tabValue} onChange={handleTabChange}>
                <Tab label="Client" />
                <Tab label="Functions" />
                <Tab label="Item List" />
                <Tab label="Finance" disabled={!state.inputObject.bookingNumber} />
                <Tab label="Document" disabled /> {/*disabled for phase 1*/}
                <Tab label="Comments" disabled={!state.inputObject.bookingNumber} />
            </Tabs>
            <ContentContainer>
                {state.showLoading && (
                    <FlexBox
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                            zIndex: 10,
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <CircularProgress size={100} />
                    </FlexBox>
                )}
                <Box>
                    {state.tabValue === 0 && (
                        <DataGrid 
                            isScrolling 
                            columns={clientGridColumns} 
                            topHeight={80} 
                            data={state.inputObject.client ? [state.inputObject.client] : []} 
                            dataItemKey={'id'} 
                            renderRows={renderClientGrid} 
                        />
                    )}
                    {state.tabValue === 1 && (
                        <DataGrid
                            columns={eventFunctionGridColumns}
                            topHeight={80}
                            data={state.inputObject.eventFunctions.sort((a, b) => {
                                if (a.eventDate < b.eventDate) return -1;
                                if (a.eventDate > b.eventDate) return 1;
                                if (a.startTime < b.startTime) return -1;
                                if (a.startTime > b.startTime) return 1;
                                if (a.endTime < b.endTime) return -1;
                                if (a.endTime > b.endTime) return 1;
                                if (a.room?.building?.buildingCode < b.room?.building?.buildingCode) return -1;
                                if (a.room?.building?.buildingCode > b.room?.building?.buildingCode) return 1;
                                if (a.room?.roomNumber < b.room?.roomNumber) return -1;
                                if (a.room?.roomNumber > b.room?.roomNumber) return 1;
                            })}
                            dataItemKey={'id'}
                            renderRows={renderEventFunctionGrid}
                            isCopyAndPaste={state.inputObject.bookingNumber}
                            renderPasteDialogBody={(sourceData, destinationData, handleClose) => {
                                return (
                                    <>
                                        <span><b><i>You are copying the function below. Please review the function details.</i></b></span>
                                        <DataGrid 
                                            data={[sourceData]} 
                                            columns={eventFunctionGridColumns}
                                            renderRows={renderEventFunctionGrid}
                                            isScrolling
                                            dataItemKey={'id'} 
                                        />
                                        <DataGrid 
                                            data={sourceData.mEventFunctionItems} 
                                            columns={applySetupsForAllDaysGridColumns}
                                            renderRows={(data: any, onChange: any, handleInputFocus: any) => {
                                                return (
                                                    <>
                                                        <TableCell sx={{ width: '11%' }}>{data?.item?.itemCategory?.name}</TableCell>
                                                        <TableCell sx={{ width: '11%' }}>{data?.item?.name}</TableCell>
                                                        <TableCell sx={{ width: '10%', textAlign: 'right' }}>{data?.quantity}</TableCell>
                                                        <TableCell sx={{ width: '10%', textAlign: 'right' }}>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data?.costPerItem)}</TableCell>
                                                        <TableCell sx={{ width: '13%', textAlign: 'right' }}>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(data?.totalCost)}</TableCell>
                                                    </>
                                                );
                                            }} 
                                            isScrolling
                                            dataItemKey={'id'} 
                                        />
                                        <FooterContent>
                                            <GlobalButton
                                                text="Paste"
                                                variant="round"
                                                onClick={async () => {
                                                    await _mEventApi.CopyManagedEventFunction(sourceData.id, destinationData.id);
                                                    const managedEvent = await _mEventApi.GetManagedEventsById(state.inputObject.id);
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        inputObject: {
                                                            ...prevState.inputObject,
                                                            id: managedEvent.id,
                                                            eCrn: managedEvent.eventCRN,
                                                            bookingNumber: managedEvent.bookingNumber,
                                                            eventTitle: managedEvent.eventTitle,
                                                            startDate: moment(managedEvent.startDate).format('YYYY-MM-DD'),
                                                            endDate: moment(managedEvent.endDate).format('YYYY-MM-DD'),
                                                            contractReceivedDate: managedEvent.contractReceivedDate ? moment(managedEvent.contractReceivedDate).format('YYYY-MM-DD') : null,
                                                            status: managedEvent.eventStatus,
                                                            rateCategory: managedEvent.rateCategory,
                                                            deposit: managedEvent.deposit,
                                                            dateFeesPaid: managedEvent.dateFeesPaid ? moment(managedEvent.dateFeesPaid).format('YYYY-MM-DD') : null,
                                                            isInternal: managedEvent.isInternal,
                                                            eventStaff: managedEvent.staffAccount,
                                                            client: managedEvent.client,
                                                            pstExemptCode: managedEvent.pstExemptCode,
                                                            fundCode: managedEvent.fundCode,
                                                            organizationCode: managedEvent.organizationCode,
                                                            accountCode: managedEvent.accountCode,
                                                            programCode: managedEvent.programCode,
                                                            activityCode: managedEvent.activityCode,
                                                            locationCode: managedEvent.locationCode,
                                                            detailsOfOtherCosts: managedEvent.detailsOfOtherCosts,
                                                            internalFOAPALComment: managedEvent.internalFOAPALComment,
                                                            generalComment: managedEvent.generalComment,
                                                            adminComment: managedEvent.adminComment,
                                                            roomSetupComment: managedEvent.roomSetupComment,
                                                            eventFunctions: [
                                                                ...managedEvent.mEventFunctions.map((eventFunction) => {
                                                                    return {
                                                                        ...eventFunction,
                                                                        mEventFunctionItems: eventFunction.mEventFunctionItems.map((mEventFunctionItem) => ({
                                                                            ...mEventFunctionItem,
                                                                            itemCategory: mEventFunctionItem.item?.itemCategory,
                                                                        })),
                                                                    };
                                                                }),
                                                            ],
                                                        },
                                                    }));
    
                                                    handleClose(true);
                                                }}
                                            />
                                        </FooterContent>
                                    </>
                                );
                            }}
                            isEdit={state.inputObject.bookingNumber}
                            isDelete={state.inputObject.bookingNumber}
                            onEditClickCallback={(id) => {
                                setState((prevState) => ({
                                    ...prevState,
                                    inputObject: {
                                        ...prevState.inputObject,
                                        eventFunctions: prevState.inputObject.eventFunctions.map((ef) =>
                                            ef.id === id ? { ...ef, isEditMode: true } : ef
                                        ),
                                    },
                                }));
                            }}
                            onCancelClickCallback={(id) => {
                                setState((prevState) => ({
                                    ...prevState,
                                    inputObject: {
                                        ...prevState.inputObject,
                                        eventFunctions: prevState.inputObject.eventFunctions.map((ef) =>
                                            ef.id === id ? { ...ef, isEditMode: false } : ef
                                        ),
                                    },
                                }));
                            }}
                            onDelete={handleEventFunctionDelete}
                            optOutIsDelete={(data) => {
                                return data.isBannerMatched;
                            }}
                            deleteDialogProps={{
                                isWarning: true,
                                buttonText: 'delete',
                                deleteItem: 'the selected event function'
                            }}
                            onSaveAsync={handleEventFunctionSave}
                            isDownloadDoc
                            optOutIsDownloadDoc={(data) => {
                                return !data.isBannerMatched;
                            }}
                            onDownloadDoc={async (data) => {
                                const doorSignDoc = await _mEventApi.GetDoorSignDoc(data.id);
                                downloadDocxFile(doorSignDoc, `Door_Sign_${moment(data.eventDate).format(MOMENT_DATE_FORMAT)}_${state.inputObject.bookingNumber}`)
                            }}
                        />
                    )}
                    {state.tabValue === 2 && (
                        <Box sx={{ background: colors.white, borderRadius: '5px' }}>
                            {state.inputObject.bookingNumber && (
                                <FlexBox sx={{ mt: '5px', mb: '10px', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
                                    <GlobalButton
                                        sx={{ m: '10px' }}
                                        variant="round"
                                        text="Apply Setups for All Days"
                                        onClick={() => {
                                            if (!state.selectedMEventItemList?.id) {
                                                toast.error('A row must be selected.');
                                                return;
                                            }
                                            handleOpenApplySetupsForAllDaysDialog();
                                        }}
                                    />
                                </FlexBox>
                            )}
                            <DataGrid
                                expandable={state.inputObject.bookingNumber}
                                renderExpandable={renderItemListGridExpandable}
                                expandByDefault={true}
                                activeCell={state.selectedMEventItemList}
                                columns={itemListGridColumns}
                                topHeight={80}
                                data={state.inputObject.eventFunctions.sort((a, b) => {
                                    if (a.eventDate < b.eventDate) return -1;
                                    if (a.eventDate > b.eventDate) return 1;
                                    if (a.startTime < b.startTime) return -1;
                                    if (a.startTime > b.startTime) return 1;
                                    if (a.endTime < b.endTime) return -1;
                                    if (a.endTime > b.endTime) return 1;
                                    if (a.room?.building?.buildingCode < b.room?.building?.buildingCode) return -1;
                                    if (a.room?.building?.buildingCode > b.room?.building?.buildingCode) return 1;
                                    if (a.room?.roomNumber < b.room?.roomNumber) return -1;
                                    if (a.room?.roomNumber > b.room?.roomNumber) return 1;
                                })}
                                dataItemKey={'id'}
                                renderRows={state.inputObject.bookingNumber ? renderItemListGridManagedEvent : renderItemListGridBannerEvent}
                            />
                        </Box>
                    )}
                    {state.tabValue === 3 && (
                        <>
                            {state.openTaxDetailBreakdownDialog && (
                                <DialogTemplate
                                    maxWidth="md"
                                    title={'Tax Detail Breakdown'}
                                    onClose={() => {
                                        setState((prevState) => ({
                                            ...prevState,
                                            openTaxDetailBreakdownDialog: false,
                                        }));
                                    }}
                                    renderContent={() => {
                                        return (
                                            <>
                                                <FlexBox sx={{ margin: '0', flexDirection: 'row', justifyContent: 'space-between', height: '100%', width: '100%' }}>
                                                    <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                                        <Typography variant="h4">GST</Typography>
                                                        <Divider sx={{ margin: '20px 0px' }} />
                                                        <>
                                                            <FinancialDialogFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                <FinanceLabel>Room Rental</FinanceLabel>
                                                                <DottedDiv />
                                                                <Label>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.roomRentalGST)}</Label>
                                                            </FinancialDialogFlexBox>
                                                        </>
                                                        {Object.entries(state.costSummary.itemCategoryGST).map(([key, value], index) => {
                                                            const keyName = key === "Room Setup" ? "Specific Room Setup and AV Details" : key;
                                                            return (
                                                                <>
                                                                    <FinancialDialogFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                        <FinanceLabel>{keyName}</FinanceLabel>
                                                                        <DottedDiv />
                                                                        <Label>
                                                                            {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.itemCategoryGST[key])}
                                                                        </Label>
                                                                    </FinancialDialogFlexBox>
                                                                </>
                                                            );
                                                        })}
                                                        <Divider sx={{ margin: '20px 0px' }} />
                                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                            <FinanceTotalInvoiceLabel>GST Total</FinanceTotalInvoiceLabel>
                                                            <FinanceTotalInvoiceLabel>
                                                                {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalGST)}
                                                            </FinanceTotalInvoiceLabel>
                                                        </FlexBox>
                                                    </FlexBox>
                                                    <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                                        <Typography variant="h4">PST</Typography>
                                                        <Divider sx={{ margin: '20px 0px' }} />
                                                        <>
                                                            <FinancialDialogFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                <FinanceLabel>Room Rental</FinanceLabel>
                                                                <DottedDiv />
                                                                <Label>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.roomRentalPST)}</Label>
                                                            </FinancialDialogFlexBox>
                                                        </>
                                                        {Object.entries(state.costSummary.itemCategoryPST).map(([key, value]) => {
                                                            const keyName = key === "Room Setup" ? "Specific Room Setup and AV Details" : key;
                                                            return (
                                                                <>
                                                                    <FinancialDialogFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                                        <FinanceLabel>{keyName}</FinanceLabel>
                                                                        <DottedDiv />
                                                                        <Label>
                                                                            {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.itemCategoryPST[key])}
                                                                        </Label>
                                                                    </FinancialDialogFlexBox>
                                                                </>
                                                            );
                                                        })}
                                                        <Divider sx={{ margin: '20px 0px' }} />
                                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                            <FinanceTotalInvoiceLabel>PST Total</FinanceTotalInvoiceLabel>
                                                            <FinanceTotalInvoiceLabel>
                                                                {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalPST)}
                                                            </FinanceTotalInvoiceLabel>
                                                        </FlexBox>
                                                    </FlexBox>
                                                </FlexBox>
                                                <FooterContent>
                                                    <GlobalButton
                                                        text="cancel"
                                                        variant="outlined"
                                                        onClick={() => {
                                                            setState((prevState) => ({
                                                                ...prevState,
                                                                openTaxDetailBreakdownDialog: false,
                                                            }));
                                                        }}
                                                    />
                                                </FooterContent>
                                            </>
                                        );
                                    }}
                                />
                            )}
                            <Box sx={{ background: colors.white, borderRadius: '1px' }}>
                                <FlexBox sx={{ mt: '5px', mb: '10px', flexDirection: 'row', justifyContent: 'space-between', height: '100%', minHeight: '30rem' }}>
                                    <FlexBox sx={{ flexDirection: 'column', width: '100%', justifyContent: 'space-between', padding: '12px' }}>
                                        <FlexBox sx={{ flexDirection: 'column' }}>
                                            <Typography variant="h3">Cost Breakdown</Typography>
                                            <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} />
                                            <FinancialFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                                <FinanceLabel>Room Rental</FinanceLabel>
                                                <Label>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.roomRentalCost)}</Label>
                                            </FinancialFlexBox>
                                            {Object.entries(state.costSummary.itemCategoryCost).map(([key, value]) => {
                                                const keyName = key === "Room Setup" ? "Specific Room Setup and AV Details" : key;
                                                return (
                                                    <>
                                                        <FinancialFlexBox sx={{ marginTop: '10px', flexDirection: 'row', justifyContent: 'space-between' }}>
                                                            <FinanceLabel>{keyName}</FinanceLabel>
                                                            <Label>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.itemCategoryCost[key])}</Label>
                                                        </FinancialFlexBox>
                                                    </>
                                                );
                                            })}
                                            <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} />
                                        </FlexBox>
    
                                        <FinancialFlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '20px' }}>
                                            <Typography variant="h4">Sub Total</Typography>
                                            <Label>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalItemAndRoomCost)}</Label>
                                        </FinancialFlexBox>
                                    </FlexBox>
                                    <FlexBox sx={{ flexDirection: 'column', width: '100%', padding: '12px' }}>
                                        <Typography variant="h3">Cost Adjustment</Typography>
                                        <Divider sx={{ marginTop: '20px', marginBottom: '20px' }} />
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%' }}>
                                                <FinanceLabel>Deposit</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%' }}>
                                                <GlobalInput type={'currency'} value={state.inputObject.deposit} name={'deposit'} onChange={handleInputObject} />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%', marginTop: '8px' }}>
                                                <FinanceLabel>Date Fee Paid</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%', marginTop: '8px' }}>
                                                <GlobalInput type="date" value={state.inputObject.dateFeesPaid} name={'dateFeesPaid'} onChange={handleInputObject} />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                        <RadioGroup row name="radio" value={state.inputObject.isInternal === null ? false : state.inputObject.isInternal} onChange={handleRadioButtonChange}>
                                            <FormControlLabel value={true} control={<Radio />} label="Internal" />
                                            <FormControlLabel value={false} control={<Radio />} label="External" />
                                        </RadioGroup>
                                        <Typography variant="h4" sx={{ marginBottom: '15px', marginTop: '10px' }}>
                                            FOAPAL
                                        </Typography>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Fund</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'3 Digits'}
                                                    inputProps={{ maxLength: 3 }}
                                                    value={state.inputObject.fundCode}
                                                    name={'fundCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Organization</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'6 Digits'}
                                                    inputProps={{ maxLength: 6 }}
                                                    value={state.inputObject.organizationCode}
                                                    name={'organizationCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Account</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'4 Digits'}
                                                    inputProps={{ maxLength: 4 }}
                                                    value={state.inputObject.accountCode}
                                                    name={'accountCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Program</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'3 Digits'}
                                                    inputProps={{ maxLength: 3 }}
                                                    value={state.inputObject.programCode}
                                                    name={'programCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '15px' }}>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Activity</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'00000'}
                                                    inputProps={{ maxLength: 5 }}
                                                    value={state.inputObject.activityCode}
                                                    name={'activityCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '22%' }}>
                                                <FinanceLabel>Location</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ width: '28%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'3 Digits'}
                                                    inputProps={{ maxLength: 3 }}
                                                    value={state.inputObject.locationCode}
                                                    name={'locationCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: '10px', marginBottom: '10px' }}>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%' }}>
                                                <FinanceLabel>PST Exemption Code</FinanceLabel>
                                            </FinancialFlexBox>
                                            <FinancialFlexBox sx={{ flexDirection: 'column', width: '50%' }}>
                                                <GlobalInput
                                                    type={'text'}
                                                    placeholder={'PST Code'}
                                                    value={state.inputObject.pstExemptCode}
                                                    name={'pstExemptCode'}
                                                    onChange={handleInputObject}
                                                />
                                            </FinancialFlexBox>
                                        </FlexBox>
                                    </FlexBox>
                                    <FlexBox sx={{ borderRadius: '10px', flexDirection: 'column', width: '100%', m: '10px', backgroundColor: '#F0F5F9', padding: '12px' }}>
                                        <Typography variant="h4" sx={{ marginBottom: '10px' }}>
                                            Summary
                                        </Typography>
    
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <FinanceLabel>Items Total</FinanceLabel>
                                            <FinanceLabel>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalItemAndRoomCost)}</FinanceLabel>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <FinanceLabel>GST</FinanceLabel>
                                            <FinanceLabel>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalGST)}</FinanceLabel>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <FinanceLabel>PST</FinanceLabel>
                                            <FinanceLabel>{new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalPST)}</FinanceLabel>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'end', marginBottom: '5px' }}>
                                            <DetailsLabel
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        openTaxDetailBreakdownDialog: true,
                                                    }));
                                                }}
                                            >
                                                Details +
                                            </DetailsLabel>
                                        </FlexBox>
                                        <Divider sx={{ marginBottom: '10px' }} />
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="h5" sx={{ marginBottom: '10px', fontSize: '14px', fontWeight: '900' }}>
                                                Sub Total
                                            </Typography>
                                            <FinanceBoldLabel>
                                                {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.totalItemAndRoomCostWithTax)}
                                            </FinanceBoldLabel>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <FinanceLabel>Deposit</FinanceLabel>
                                            <FinanceLabel>- {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(state.costSummary.depositPaid)}</FinanceLabel>
                                        </FlexBox>
                                        <Divider sx={{ marginTop: '10px', marginBottom: '10px' }} />
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <Typography variant="h5" sx={{ marginBottom: '10px', fontSize: '14px', fontWeight: '900' }}>
                                                Total
                                            </Typography>
                                            <FinanceBoldLabel>
                                                {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                                                    state.costSummary.totalItemAndRoomCostWithTax - state.costSummary.depositPaid,
                                                )}
                                            </FinanceBoldLabel>
                                        </FlexBox>
                                        <FlexBox sx={{ flexDirection: 'row', justifyContent: 'space-between', marginTop: 'auto', marginBottom: '20px' }}>
                                            <FinanceTotalInvoiceLabel>Total Invoice:</FinanceTotalInvoiceLabel>
                                            <FinanceTotalInvoiceLabel>
                                                {new Intl.NumberFormat('en-ca', { style: 'currency', currency: 'CAD', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
                                                    state.costSummary.totalItemAndRoomCostWithTax - state.costSummary.depositPaid,
                                                )}
                                            </FinanceTotalInvoiceLabel>
                                        </FlexBox>
                                    </FlexBox>
                                </FlexBox>
                            </Box>
                        </>
                    )}
                    {state.tabValue === 4 && <></>}
                    {state.tabValue === 5 && (
                        <>
                            <Box sx={{ background: colors.white, borderRadius: '5px' }}>
                                <FlexBox sx={{ mt: '5px', mb: '10px', flexDirection: 'row', justifyContent: 'space-between', height: '100%' }}>
                                    <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                        <ActionContainer>
                                            {/*<FinanceLabel>Internal FOAPAL</FinanceLabel>*/}
                                            {/*<GlobalInput*/}
                                            {/*    type={'text'}*/}
                                            {/*    multiline*/}
                                            {/*    minRows={6}*/}
                                            {/*    placeholder={'This is cross-charge information'}*/}
                                            {/*    value={state.inputObject.internalFOAPALComment}*/}
                                            {/*    name={'internalFOAPALComment'}*/}
                                            {/*    onChange={handleInputObject}*/}
                                            {/*/>*/}
                                            <FinanceLabel>Specific Room Setup and AV Details</FinanceLabel>
                                            <RichTextEditorProvider editor={richEditor}>
                                                <Box sx={{
                                                    border: `1px solid ${state.isRichTextEditorFocused ? colors.blue.main : colors.border}`,
                                                    borderRadius: '4px', 
                                                    padding: '5px 15px',
                                                    color: colors.blue.main,
                                                    '&:hover': {
                                                        borderColor: colors.blue.main
                                                    },
                                                }}>
                                                    <MenuControlsContainer sx={{
                                                        borderBottom: `1px solid ${colors.border}`,
                                                        paddingBottom: '5px'
                                                    }}>
                                                        <MenuSelectHeading />
                                                        <MenuDivider />
                                                        <MenuButtonBold />
                                                        <MenuButtonItalic />
                                                        <MenuButtonUnderline />
                                                        <MenuButtonStrikethrough/>
                                                        <MenuDivider />
                                                        <MenuButtonBulletedList />
                                                        <MenuButtonOrderedList />
                                                    </MenuControlsContainer>
                                                    <RichTextContent sx={{
                                                        paddingTop: '5px',
                                                        height: '400px',
                                                        maxHeight: '400px',
                                                        overflowY: 'auto',
                                                        '& div': {
                                                            height: '100%'
                                                        }
                                                    }} />
                                                </Box>
                                            </RichTextEditorProvider>
                                        </ActionContainer>
                                    </FlexBox>
                                    <FlexBox sx={{ flexDirection: 'column', width: '100%' }}>
                                        <ActionContainer>
                                            <FinanceLabel>General (From the Description Field in Banner)</FinanceLabel>
                                            <GlobalInput
                                                type={'text'}
                                                multiline
                                                minRows={6}
                                                placeholder={'This comment will be shown on the event summary/confirmation'}
                                                value={state.inputObject.generalComment}
                                                name={'generalComment'}
                                                onChange={handleInputObject}
                                            />
                                            <FinanceLabel>Admin only (For internal review only and specific to this booking)</FinanceLabel>
                                            <GlobalInput
                                                type={'text'}
                                                multiline
                                                minRows={6}
                                                placeholder={'This comment is not meant for clients to see'}
                                                value={state.inputObject.adminComment}
                                                name={'adminComment'}
                                                onChange={handleInputObject}
                                            />
                                            <FinanceLabel>Additional Comments (for RTI and Confirm)</FinanceLabel>
                                            <GlobalInput
                                                type={'text'}
                                                multiline
                                                minRows={6}
                                                placeholder={'Additional Comments (for RTI and Confirm)'}
                                                value={state.inputObject.detailsOfOtherCosts}
                                                name={'detailsOfOtherCosts'}
                                                onChange={handleInputObject}
                                            />
                                        </ActionContainer>
                                    </FlexBox>
                                </FlexBox>
                            </Box>
                        </>
                    )}
                </Box>
            </ContentContainer>
        </>
    );
};

const IconContainer = styled.span`
    display: flex;
    align-items: center;
`;

const ActionContainer = styled.div`
    border-radius: 5px;
    padding: 12px;

    & > * {
        margin-bottom: 5px;
    }

    h4 {
        color: ${colors.black};
        padding-bottom: 5px;
    }

    h4 {
        color: ${colors.black};
        padding-bottom: 5px;
    }
`;

const FlexBox = styled(Box)`
    && {
        display: flex;

        & > * {
            margin-right: 10px;
        }
    }
`;

const FinancialDialogFlexBox = styled(FlexBox)`
    && {
        margin: 5px 0px;
    }
`;

const DottedDiv = styled.div`
    && {
        flex-grow: 1;
        border-bottom: 1px dashed ${colors.grey.medium};
        align-self: center;
        margin: 0 8px; // Optional: adds spacing between items
    }
`;

const FinancialFlexBox = styled(FlexBox)`
    && {
        & > * {
            margin-right: 0px;
        }
    }
`;

const Label = styled.div`
    color: #0085e6;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 2px !important;

    & > span {
        color: #d73948;
    }
`;

const OtherCostDetailsCommentLabel = styled(Label)`
    & > * {
        margin-right: 5px;
    }
`;

const ClientCommentLabel = styled(Label)`
    margin-top: 25px;
`;

const FinanceLabel = styled(Label)`
    color: ${colors.black};
    font-size: 14px;
    font-weight: 300;
    & > span {
        text-align: right;
    }
`;

const DetailsLabel = styled(Label)`
    margin: 0;
    padding: 5px 10px;
    border-radius: 10px;

    &:hover {
        cursor: pointer;
        background: ${colors.blue.light};
    }
`;

const FinanceBoldLabel = styled(FinanceLabel)`
    font-weight: 900;
`;

const FinanceTotalInvoiceLabel = styled(FinanceLabel)`
    font-weight: 500;
    font-size: 20px;
`;

const FooterContent = styled.div`
    padding-top: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: end;
`;

const CommandTableCell = styled(TableCell)`
    && {
        svg {
            width: 20px;
            height: auto;

            path {
                fill: ${colors.grey.medium};
            }
        }

        &:hover {
            cursor: pointer;
        }

        #check {
            &:hover {
                path {
                    fill: ${colors.blue.main};
                }
            }
        }

        #edit {
            &:hover {
                path {
                    fill: ${colors.blue.main};
                }
            }
        }

        #clear {
            width: 22px;
            margin-left: 5px;

            &:hover {
                path {
                    fill: ${colors.red.main};
                }
            }
        }
    }
`;

export default BannerEventDetails;

const clientGridColumns = [
    {
        id: 'clientCompany',
        label: 'Company',
        disabled: true,
    },
    {
        id: 'clientSubCompany',
        label: 'Sub Company',
        disabled: true,
    },
    {
        id: 'clientFirstName',
        label: 'First Name',
        disabled: true,
    },
    {
        id: 'clientLastName',
        label: 'Last Name',
        disabled: true,
    },
    {
        id: 'clientContactEmail',
        label: 'Contact Email',
        disabled: true,
    },
    {
        id: 'clientContactPhoneNumber',
        label: 'Contact Phone #',
        disabled: true,
    },
    {
        id: 'clientComment',
        label: 'Comment',
        disabled: true,
    },
];

const eventFunctionGridColumns = [
    {
        id: '',
        label: '',
        disabled: true
    },
    {
        id: 'eventDate',
        label: 'Date',
    },
    {
        id: 'startTime',
        label: 'Start Time',
        disabled: true,
    },
    {
        id: 'endTime',
        label: 'End Time',
        disabled: true,
    },
    {
        id: 'building',
        label: 'Building',
        disabled: true,
    },
    {
        id: 'room',
        label: 'Room',
        disabled: true,
    },
    {
        id: 'numberOfAttendees',
        label: '#Attend.',
        disabled: true,
        // numeric: true,
    },
    {
        id: 'cost',
        label: 'Cost',
        disabled: true,
        // numeric: true,
    },
    {
        id: 'comment',
        label: 'Comment',
        disabled: true,
    },
];

const itemListGridColumns = [
    {
        id: 'eventDate',
        label: 'Date',
    },
    {
        id: 'startTime',
        label: 'Start Time',
        disabled: true,
    },
    {
        id: 'endTime',
        label: 'End Time',
        disabled: true,
    },
    {
        id: 'building',
        label: 'Building',
        disabled: true,
    },
    {
        id: 'room',
        label: 'Room',
        disabled: true,
    },
    {
        id: 'numberOfAttendees',
        label: '#Attend.',
        disabled: true,
    },
    {
        id: 'comment',
        label: 'Comment',
        disabled: true,
    },
];

const newItemListDialogGridColumns = [
    {
        id: 'name',
        label: 'Item',
    },
    {
        id: 'description',
        label: 'Description',
        disabled: true,
    },
];

const applySetupsForAllDaysGridColumns = [
    {
        id: 'category',
        label: 'Category',
        disabled: true,
    },
    {
        id: 'item',
        objectId: 'name',
        label: 'Item',
        disabled: true,
    },
    {
        id: 'quantity',
        label: '# of Item',
        disabled: true,
        // numeric: true
    },
    {
        id: 'costPerItem',
        label: 'Cost Per Item',
        disabled: true,
        // numeric: true
    },
    {
        id: 'totalCost',
        label: 'Total Charge',
        disabled: true,
        // numeric: true
    },
];
